import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Breadcrumb } from "@themesberg/react-bootstrap";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DataTable from "../../components/DataTable";
import { getModulosAction } from "../../actions/modulosAction";
import { getMenusAction } from "../../actions/menuActions";
import { obtenerRolesMenuAction } from "../../actions/rolesMenusActions";

import { ConfirmModal } from "../../components/ConfirmModal";
import clienteAxios from "../../config/axios";
import SucursalesForm from "./SucursalesForm";
import Swal from "sweetalert2";

export default () => {
  const [showModal, setShowModal] = useState(false);
  const [sucursales, setSucursales] = useState([]);
  const [selected, setSelected] = useState({});
  const [accionForm, setAccionForm] = useState("agregar");

  useEffect(() => {
    getSucursales();
  }, []);

  const getSucursales = () => {
    clienteAxios.get("sucursales").then((respuesta) => {
      if (respuesta && respuesta.data.data && respuesta.data.success === true) {
        setSucursales(respuesta.data.data);
      }
    });
  };

  const columns = [
    {
      key: "id",
      text: "ID",
      sortable: true,
    },
    {
      key: "nombre",
      text: "Nombre",
      sortable: true,
    },
    {
      key: "direccion",
      text: "Dirección",
      sortable: true,
    },
    {
      key: "telefono",
      text: "Teléfono",
      sortable: true,
    },
  ];

  const extraButtons = [
    {
      className: "btn btn-info",
      title: "Agregar rol",
      children: [
        <span>
          <i class="fas fa-plus"></i> Nuevo
        </span>,
      ],
      onClick: (event) => {
        setShowModal(true);
        setAccionForm("agregar");
      },
    },
  ];

  const editRecord = (record) => {
    setSelected(record);
    setShowModal(true);
    setAccionForm("editar");
  };

  const deleteRecord = (record) => {
    const callbacks = [
      {
        event: eliminarSucursal,
        args: [record.id],
      },
    ];

    ConfirmModal(callbacks);
  };

  const eliminarSucursal = (id) => {
    clienteAxios.delete("sucursales/" + id).then((respuesta) => {
      if (respuesta && respuesta.data.data && respuesta.data.success === true) {
        Swal.fire("¡Muy bien!", respuesta.data.message, "success");
        setSucursales(sucursales.filter((row) => row.id !== id));
      }
    });
  };

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
          >
            <Breadcrumb.Item>
              <FontAwesomeIcon icon={faHome} />
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Sucursales</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>
      <Card border="light" className="table-wrapper table-responsive shadow-sm">
        <Card.Body>
          <h5 className="mb-4">Sucursales</h5>
          <DataTable
            columns={columns}
            editRecord={editRecord}
            deleteRecord={deleteRecord}
            state={{ records: sucursales }}
            extraButtons={extraButtons}
          />
        </Card.Body>
      </Card>

      <SucursalesForm
        accion={accionForm}
        showModal={showModal}
        selectedRow={selected}
        onUpdate={(rowSuccess) => {
          setSucursales(
            sucursales.map((row) =>
              row.id === rowSuccess.id ? (row = rowSuccess) : row
            )
          );

          setShowModal(false)
        }}
        onCreate={(rowSuccess) => {
          setSucursales(sucursales.concat(rowSuccess));

          setShowModal(false)
        }}
        onHide={() => setShowModal(false)}
      />
    </>
  );
};
